<template>
<div id="infraestructura">
    <div class="container-fluid">
         <div class="row main-content">
           <div class="small-title-top pull-left">
                        <h4 v-html="state.title"></h4><hr>
                    </div>
                    <div class="destinos-main-container" data-aos="fade-right">
                        <h1>{{state.subTitle}}</h1>
                    </div>
         <div class="col-md-12 map-container" data-aos="fade-up">
        <div id="myCarousel" class="carousel slide" data-ride="carousel">
    <!-- Indicators -->
    <ol class="carousel-indicators">
      <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
      <li data-target="#myCarousel" data-slide-to="1"></li>
      <li data-target="#myCarousel" data-slide-to="2"></li>
      <li data-target="#myCarousel" data-slide-to="3"></li>
      <li data-target="#myCarousel" data-slide-to="4"></li>
    <li data-target="#myCarousel" data-slide-to="5"></li>


    </ol>

    <!-- Wrapper for slides -->
    <div class="carousel-inner">

      <div class="item active">
        <img :src="imgUrl(state.imgInv1)" alt="Los Angeles" style="width:85%; margin:auto; top:-100px;">  
      </div>
      <div class="item">
        <img :src="imgUrl(state.imgInv2)" alt="Los Angeles" style="width:85%; margin:auto; top:-100px;">  
      </div>
      <div class="item">
        <img :src="imgUrl(state.imgInv3)" alt="Los Angeles" style="width:85%; margin:auto; top:-100px;">  
      </div>
      <div class="item">
        <img :src="imgUrl(state.imgInv4)" alt="Los Angeles" style="width:85%; margin:auto; top:-100px;">  
      </div>
      <div class="item">
        <img :src="imgUrl(state.imgInv5)" alt="Los Angeles" style="width:85%; margin:auto; top:-100px;">  
      </div>
       <div class="item">
        <img :src="imgUrl(state.imgInv6)" alt="Los Angeles" style="width:85%; margin:auto; top:-100px;">  
      </div>

  
    </div>

    <!-- Left and right controls -->
    <a class="left carousel-control" href="#myCarousel" data-slide="prev">
      <span class="glyphicon glyphicon-chevron-left"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="right carousel-control" href="#myCarousel" data-slide="next">
      <span class="glyphicon glyphicon-chevron-right"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
    </div>
    <div class="col-md-12 video-container" data-aos="fade-down">
        <iframe style="margin-top:80px; margin-bottom:60px;" src="https://www.youtube.com/embed/IkrArzW-96M?rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe>
    </div>
        </div>
    </div>
    <div class="col-md-12 footer-container" style="padding:20px;">
                <router-link to="/contacto" tag="a"><h3>CONTÁCTANOS</h3></router-link>
                <hr style="border-top:1px solid white;">
                <p>Copy right @2017 - All Rights Reserved</p>
     </div>
</div>
</template>

<script>

export default { 

  methods:{
      imgUrl(url){
          return require('@/assets/imgs/' + url + '.png')
      }
  },
  components:{  
  },
  computed:{
      state(){
          return this.$store.state.activeList.inventarioPage
      },
  },
  mounted(){

  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

iframe{
     width:70%; 
     height:515px;
}
.footer-container{
    background-color:$gris;
    color:white;
}

a{
    color:white;
}
.main-content{
    display:block;
    color:$gris;
}
.map-container{
}

.carousel{
    width:80%;
    margin:auto;
    background-color:transparent;
}

.carousel img{
    z-index:100;
}
.carousel-inner{
    z-index:3;
}
.carousel-control{
    background-color:$rojo;
    height:500px;
    margin-top:100px;
}

.carousel-control, .carousel-control{
    opacity:1!important;
        background-color:$rojo;

}
.carousel-control:focus, .carousel-control:hover{
    opacity:1!important;
        background-color:$rojo;

}

.carousel-control.left {
    background-image: none;
}

.carousel-control.right {
    background-image: none;
}
.carousel-control{
    width:50%;
}
hr{
    display:inline-block;
    vertical-align:middle;
    height: 2px;
    border: 0;
    width:20%;
    border-top: 2px solid $azul;
    margin: 1em 1em;
    padding: 0; 

}
h1{
    font-size:80pt;
}
img{
        width: 100%;
}
.text-container{
    text-align:right;
    margin-top:5%;
}

.small-title{
    width:100%;
    text-align:right;
    vertical-align:middle;
}

.small-title-top{
    margin-top:150px;
    width:100%;
    text-align:left;
    vertical-align:middle;
    padding:80px;
}

.small-title-top hr{
        border-top: 2px solid $rojo;

}

.info-container{
    color:white;
    text-align:right;
        position:absolute;
        padding:40px;

}

h4{
    display:inline-block;
}

.cornered {
    width: 50%;
    box-sizing:border-box;
    border-bottom: 28em solid $rojo;
    border-left: 7em solid transparent;
}

.destinos-main-container{
    text-align:left;
    padding:80px;
}
.destinos-main-container h1{
    color:$azul!important;
    
}

.glyphicon-chevron-left{
    margin-left: -300px;
}

.glyphicon-chevron-right{
   margin-right: -300px;
}

@media screen and (max-width:1261px) {
iframe{
     width:90%; 
     height:515;
}

.destinos-main-container{
    padding:60px;
}

.small-title-top{
    padding:10px;
}

h1{
    font-size:40pt;
}
.carousel-control{
    width:0%;
}

.glyphicon-chevron-left{
    margin-left:140px;
    z-index:9;
}

.glyphicon-chevron-right{
   margin-right: 140px;
       z-index:9;


}

.carousel{
    width:100%;
    margin:auto;
    background-color:transparent;
}
}
</style>



// WEBPACK FOOTER //
// infraestructura.vue?728be181